import { useMemo } from 'react';
import MojitoPresentation from 'mojito/presentation';
import SuspendedSelectionLabel from 'modules/betslip/betslip-view/bet-components/suspended-selection-label/index.js';
import RemoveSelection from 'modules/betslip/betslip-view/bet-components/remove-selection/index.js';
import BonusIndicator from 'modules/bonus-indicator/index.js';
import BonusIndicatorTypes from 'modules/bonus-indicator/types.js';
import BetViewUtils from 'modules/your-bets/bet-view/utils.js';

const { FlexPane, Image, Text, VoidReasonMessage, BetStatusIcon } = MojitoPresentation.Components;

const MatchAccaSelectionItem = props => {
    const {
        selectionId,
        showSeparator,
        selectionLabel,
        isRedundant,
        marketName,
        eventName,
        isSuspended,
        earlyPayout,
        allowSelectionRemoval,
        voidReason,
        status,
        mojitoTools: { config, style, stringResolver },
    } = props;
    const hasEarlyPayout = !!earlyPayout;
    const bonusInfo = useMemo(() => ({ rules: earlyPayout?.rules }), [earlyPayout]);
    const statusIconKey = status ? BetViewUtils.getStatusIcon(status) : undefined;
    const showLabelsInnerContent = hasEarlyPayout || voidReason;
    const showLabelsContent = showLabelsInnerContent || isSuspended;

    return (
        <FlexPane config={config.selectionContainer} class="ta-MatchAccaSelectionItem">
            <FlexPane config={config.selectionIconContainer}>
                <FlexPane class="ta-separator-line-top" config={style.separatorLineTop} />
                {statusIconKey ? (
                    <BetStatusIcon config={config.selectionStatusIcon} status={statusIconKey} />
                ) : (
                    <Image config={config.selectionIcon} class="ta-SingleBet-selectionIcon" />
                )}
                {showSeparator && (
                    <FlexPane class="ta-separator-line-bottom" config={style.separatorLineBottom} />
                )}
            </FlexPane>
            <FlexPane config={config.marketInfoContainer}>
                <Text
                    config={isRedundant ? style.redundantSelectionLabel : config.selectionLabel}
                    class="ta-MatchAccaSelectionName"
                >
                    {selectionLabel}
                    {marketName && (
                        <>
                            <span>{` ${stringResolver.resolveString('$MATCH_ACCA_SELECTION_ITEM.SEPARATOR')} `}</span>
                            <span style={config.marketName}>{marketName}</span>
                        </>
                    )}
                </Text>
                {eventName && (
                    <Text config={config.eventName} class="ta-MatchAccaEventName">
                        {eventName}
                    </Text>
                )}
                {showLabelsContent && (
                    <FlexPane config={config.labelsContainer}>
                        {showLabelsInnerContent && (
                            <FlexPane config={config.labelsInnerContainer}>
                                {hasEarlyPayout && (
                                    <BonusIndicator
                                        class="ta-earlyPayoutIndicator"
                                        config={config.earlyPayoutIndicator}
                                        bonusType={BonusIndicatorTypes.TYPES.EARLY_PAYOUT}
                                        bonusInfo={bonusInfo}
                                        isAwarded={earlyPayout.awarded}
                                    />
                                )}
                                <VoidReasonMessage
                                    config={config.voidReasonMessage}
                                    reason={voidReason}
                                />
                            </FlexPane>
                        )}
                        {isSuspended && (
                            <SuspendedSelectionLabel config={config.suspendedSelectionLabel} />
                        )}
                    </FlexPane>
                )}
            </FlexPane>
            {allowSelectionRemoval && (
                <RemoveSelection config={config.removePartSelection} selectionId={selectionId} />
            )}
        </FlexPane>
    );
};

MatchAccaSelectionItem.getStyle = (config, mode, merge) => ({
    separatorLineTop: merge(config.separatorLineBase, config.separatorLineTop),
    separatorLineBottom: merge(config.separatorLineBase, config.separatorLineBottom),
    redundantSelectionLabel: merge(config.selectionLabel, config.redundantSelectionLabel),
});

export default MatchAccaSelectionItem;
